// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ou-2";
export var chatLink = "_ou-0";
export var chatText = "_ou-1";